import { GEOSERVER_ZONES } from 'other/config';
import { LAYERS } from 'other/map/layers';
import { ZONES_WITH_INFO } from './mapEntitiesConstants';
import { EProtectedZone, TLayerPointLocation, TZoneInfo } from 'types';

/**/
type ZoneResponse = {
  crs: Object;
  features: ZoneFeature[];
  numberMatched: number;
  numberReturned: number;
  timeStamp: string;
  totalFeatures: number;
  type: 'FeatureCollection';
};

/**/
type ZoneFeature = {
  geometry: Object;
  geometry_name: string;
  id: string;
  properties: Record<string, string>;
  type: 'Feature';
};

/**/
const PROPERTIES_MAP = {
  [EProtectedZone.NO_PROTECTED_TCA]: [
    'area_name',
    'description',
    'name',
    'speciestype_name',
    'type_name'
  ],
  [EProtectedZone.NO_PROTECTED_CCR]: ['name', 'paragraph'],
  [EProtectedZone.NO_PROTECTED_CCNG]: ['description', 'name'],
  [EProtectedZone.NO_PROTECTED_PZS]: ['info'],
  [EProtectedZone.NO_SEISMIC_ONGOING]: [
    'actual_start_date',
    'planned_end_date',
    'planned_start_date',
    'survey_company',
    'survey_type'
  ],
  [EProtectedZone.NO_SEISMIC_PLANNED]: [
    'planned_end_date',
    'planned_start_date',
    'survey_company',
    'survey_type'
  ],
  [EProtectedZone.SCOTTISH_MPA]: ['objnam', 'inform', 'restrn']
};

/**
 *
 */
function lonLatToMercator(lon, lat) {
  const R = 6378137.0;

  return {
    x: lon * (Math.PI / 180) * R,
    y: Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 180 / 2)) * R
  };
}

/**/
const NO_ZONES_TYPES = Object.entries(LAYERS)
  .filter(([key]) => ZONES_WITH_INFO.includes(key as EProtectedZone))
  .map(([_, val]) => val['NAME']);

/**
 *
 */
export function fetchZoneDescription(
  location: TLayerPointLocation
): Promise<TZoneInfo[] | void> {
  const { x, y } = lonLatToMercator(location.longitude, location.latitude);

  const url =
    GEOSERVER_ZONES +
    '?service=WFS&version=1.1.0&request=GetFeature' +
    `&typeName=${NO_ZONES_TYPES.join(',')}` +
    '&outputFormat=application/json&srsName=EPSG:3857' +
    '&FILTER=<ogc:Filter xmlns:ogc="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml">' +
    '<ogc:Intersects><ogc:PropertyName>geom</ogc:PropertyName>' +
    `<gml:Point srsName="EPSG:3857"><gml:coordinates>${x},${y}</gml:coordinates></gml:Point>` +
    '</ogc:Intersects></ogc:Filter>';

  return fetch(decodeURIComponent(url))
    .then((r) => r.json())
    .then((resp: ZoneResponse) => resp.features.map(mapFeature));
  // .then(console.log);
}

/**
 *
 */
function mapFeature(feature: ZoneFeature): TZoneInfo {
  const [name] = Object.entries(LAYERS).find(([_, val]) => {
    const _name = feature.id.split('.')[0];
    return val['NAME']?.endsWith(_name);
  });

  const validProps = PROPERTIES_MAP[name];
  const props = {};

  Object.entries(feature.properties).forEach(([key, val]) => {
    if (validProps.includes(key)) props[key] = val;
  });

  return {
    id: feature.id,
    name: name as EProtectedZone,
    properties: props
  };
}
